import React from "react";
import ReactDOM from "react-dom/client";
import "./index.scss";
import "./GlobalConfig.css";
import "./cryptoEdge.scss";
import App from "./App";
import {store, persistor} from "./store/configureStore";
import {PersistGate} from "redux-persist/integration/react";
import {Provider} from "react-redux";
import "react-toastify/dist/ReactToastify.css";

import { setupAxiosInterceptors } from "./utils/apis/axiosSetup";

// Initialize global Axios interceptor once
setupAxiosInterceptors();


const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <Provider store={store}>
    <PersistGate
      loading={null}
      persistor={persistor}
    >
      <App />
    </PersistGate>
  </Provider>,
);
// Register Service Worker for Firebase Messaging
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/firebase-messaging-sw.js")
      .then((registration) => {
        console.log("Status: Service Worker registered with scope:", registration.scope);
      })
      .catch((err) => {
        console.error("Status: Service Worker registration failed:", err);
      });
  });
}
